import { query, getDocs, where } from "firebase/firestore";
import { Client, ConsultingServicesAgreement } from "@freetech/models/projects";
import { IFeatureRequest, Project } from "@freetech/models";
import { loadNestedClients } from "core/admin/clients";
import { db } from "@freetech/models/db";

export const loadClientsNonAdmin = async (
  role: string,
  currentUserId: string
): Promise<Client[]> => {
  if (role === "admin") {
    console.log("loading nested clients");
    return loadNestedClients();
  }
  try {
    const q = query(
      db.clients,
      where(
        role === "freelancer"
          ? "associatedFreelancerIds"
          : "associatedStakeholderIds",
        "array-contains",
        currentUserId
      )
    );
    const querySnapshot = await getDocs(q);
    const clientsData: Client[] = [];

    for (const doc of querySnapshot.docs) {
      const clientData = { ...doc.data(), id: doc.id };
      const projectsSnapshot = await getDocs(db.projects(doc.id));
      const projectsData: Project[] = projectsSnapshot.docs.map(
        (projectDoc) => ({
          ...projectDoc.data(),
          id: projectDoc.id,
        })
      );
      clientData.projects = projectsData;

      if (role === "stakeholder") {
        const consultingServicesAgreementsSnapshot = await getDocs(
          db.consultingServicesAgreements(doc.id)
        );
        const consultingServicesAgreementsData: ConsultingServicesAgreement[] =
          consultingServicesAgreementsSnapshot.docs.map((csaDoc) => ({
            ...csaDoc.data(),
            id: csaDoc.id,
          }));

        clientData.consultingServicesAgreements =
          consultingServicesAgreementsData;
      }
      clientsData.push({
        ...clientData,
        id: doc.id,
      });
    }
    return clientsData;
  } catch (error) {
    console.error("Error loading clients:", error);
    throw error;
  }
};
